import React from 'react';

import { Grid, Paper, Stack } from '@mui/material';

import { ResourceInfoFragment } from 'src/api';
import { FullscreenLoader } from 'src/components/common';
import { ResourceCard } from 'src/components/resource';
import { useScreenInfo } from 'src/hooks/common';
import { useResourceList } from 'src/hooks/resources/useResourceList';

import { ResourcesPageGroup } from './ResourcesPageGroup';

export const ResourcesPage: React.FC = () => {
  const { loading: resourceListLoading, resourcesList } = useResourceList();
  const { isMobile } = useScreenInfo();

  const loading = resourceListLoading;

  const sortedResourcesList = React.useMemo(() => {
    const sortedResourcesList: { [key: string]: ResourceInfoFragment } = {};

    for (const resource of resourcesList) {
      if (resource.title) {
        sortedResourcesList[resource.title.trim()] = resource;
      }
    }

    return sortedResourcesList;
  }, [resourcesList]);

  if (loading) {
    return <FullscreenLoader />;
  }

  if (isMobile) {
    return (
      <Stack gap={4}>
        <ResourcesPageGroup
          title="Useful Cards"
          subtitle="Just some hints on how to use our product"
        >
          <Stack direction="column" spacing={2}>
            {resourcesOrder.map(resource => {
              const card = sortedResourcesList[resource];
              if (!card) return null;
              return (
                <Paper key={card.id} variant="outlined">
                  <ResourceCard resource={card} />
                </Paper>
              );
            })}
          </Stack>
        </ResourcesPageGroup>
      </Stack>
    );
  }

  return (
    <ResourcesPageGroup title="Useful Cards" subtitle="Just some hints on how to use our product">
      <Grid container spacing={2}>
        {resourcesOrder.map(resource => {
          const card = sortedResourcesList[resource];
          if (!card) return null;
          return (
            <Grid key={card.id} size={{ xs: 12, md: 6, lg: 4 }}>
              <ResourceCard resource={card} />
            </Grid>
          );
        })}
      </Grid>
    </ResourcesPageGroup>
  );
};

const resourcesOrder = ['User Guides', 'Privacy Policy', 'Contact Us'] as const;
